// extracted by mini-css-extract-plugin
export var buttonContainer = "_92-1";
export var fontSizeSelect = "_92-3";
export var formatSelect = "_92-2";
export var formats = "_92-4";
export var hidden = "_92-5";
export var icon = "_92-6";
export var select = "_92-0";